import { SwiperSlide } from 'swiper/react'
import { Carousel } from './Carousel'
import { CarouselButton } from './CarouselButton'

export default {
  Container: Carousel,
  Slide: SwiperSlide,
  Button: CarouselButton,
}
